<template>
<span>
  <Breadcrumb v-if="protocol" :protocol="protocol" :categories="categories"></Breadcrumb>
  <main id='protocol'>
      <aside class="refine">
        <Categories></Categories>
      </aside>

      <section class="results protocol">
        <div v-if="protocol" id="title-block">

          <div class="protocol-title">
            <h1 id="title">{{ protocol.title }}</h1>
          </div>

        </div>

        <div class="selected-protocol">

        <Error404Page v-if="is404"></Error404Page>

        <span v-if="protocol">
          <Protocol :protocol="protocol" :headers="topHeaders"></Protocol>

          <div class='robot-tab'>
            <span
              v-for="tab in allTabs"
              v-if="downloadUrls[tab]"
              v-bind:class="{selected: (tab === currentTab)}"
              v-on:click="navigateTab(tab)"
            >
              {{tabNames[tab]}}
            </span>
            <span class='filler'></span>
          </div>

          <h2 class='download-protocol-header'>Download Protocol:</h2>

          <ParameterizeAndDownload
            v-if="protocol.flags['embedded-app'] === false && downloadUrls[currentTab]"
            :downloadUrl="downloadUrls[currentTab]"
            :protocolSlug="protocol.slug"
            :robotTab="tabNames[currentTab]"
            :protocolData="protocolData"
          />
          <Setup v-if="currentTab === 'ot1'" :protocol="selectedOT1protocol"></Setup>
          <div class='ot2_deck_map_wrapper'>
            <div class='ot2_deck_map'>
              <iframe
                v-if="currentTab === 'ot2'"
                :src="ot2DeckUrl"
              />
            </div>
          </div>
          <Protocol :protocol="protocol" :headers="bottomHeaders"></Protocol>
        </span>

        <EmbeddedApp v-if="getIframeSrc" :src="getIframeSrc"></EmbeddedApp>
      </div>

      <button v-if="protocol" class="back-to-top" v-on:click="backToTop">
        BACK TO TOP
      </button>
    </section>
  </main>
</span>
</template>

<script>
  import Breadcrumb from './Breadcrumb.vue'
  import Categories from './Categories.vue'
  import Error404Page from './Error404Page.vue'
  import Setup from './Setup.vue'
  import Protocol from './Protocol.vue'
  import EmbeddedApp from './EmbeddedApp.vue'
  import ParameterizeAndDownload from './ParameterizeAndDownload'
  import db from '../store/db'
  import util from '../util'

  export default {
    name: 'ProtocolView',
    data () {
      return {
        topHeaders: [
          ['author', 'Author'],
          ['partner', 'Partner Lab'],
          ['description', 'Description'],
          ['time-estimate', 'Time Estimate'],
          // ['robot', 'Robots'],
          ['modules', 'Modules'],
          ['labware', 'Labware'],
          ['pipettes', 'Pipettes'],
          ['reagents', 'Reagents'],
          ['deck-setup', 'Deck Setup'],
          ['reagent-setup', 'Reagent Setup'],
          ['protocol-steps', 'Protocol Steps']
        ],
        bottomHeaders: [
          ['process', 'Process'],
          ['notes', 'Additional Notes']
        ],
        protocol: null,
        is404: false,
        downloadUrls: {},
        origin: null,
        allTabs: [],
        currentTab: null
      }
    },
    beforeRouteEnter (to, from, next) {
      next((vm) => {
        if (from.name === 'category-query') {
          vm.origin = from
        }
      })
    },
    computed: {
      categories: function () {
        return [
          this.origin ? this.origin.params.category : null,
          this.origin ? this.origin.params.subCategory : null
        ]
      },
      selectedOT1protocol: function () {
        // NOTE: only 1 file is supported now, so the first is "selected"
        return (
          this.protocol &&
          this.protocol.protocols &&
          this.protocol.protocols['OT 1 protocol'] &&
          this.protocol.protocols['OT 1 protocol'][0]
        )
      },
      selectedOT2protocol: function () {
        // NOTE: only 1 file is supported now, so the first is "selected"
        return (
          this.protocol &&
          this.protocol.protocols &&
          this.protocol.protocols['OT 2 protocol'] &&
          this.protocol.protocols['OT 2 protocol'][0]
        )
      },
      ot2DeckUrl: function () {
        const baseUrl = 'https://s3-us-west-2.amazonaws.com/protocol-library-kludge/production/index.html'
        const selectedOT2protocol = this.selectedOT2protocol

        const labwareArray = (selectedOT2protocol && selectedOT2protocol.labware) || []

        const labware = labwareArray.reduce((acc, l) => ({
          ...acc,
          [l.slot]: {
            labwareType: l.type,
            name: l.name
          }
        }), {})

        const modulesArray = (selectedOT2protocol && selectedOT2protocol.modules) || []

        const modules = modulesArray.reduce((acc, module) => ({
          ...acc,
          [module.slot]: module.name
        }), {})

        const encodedJson = window.encodeURI(JSON.stringify({
          labware,
          modules
        }))

        return baseUrl + '?data=' + encodedJson
      },
      protocolData: function () {
        const protocolType = this.currentTab === 'ot1' ? 'OT 1 protocol' : 'OT 2 protocol'

        const protocolsOfType = this.protocol &&
        this.protocol.protocols &&
        this.protocol.protocols[protocolType]

        // TODO: Ian 2018-09-06 support multiple protocol files
        // (eg dinosaur1.ot1.py + dinosaur2.ot1.py together)
        const numProtocolsOfType = protocolsOfType.length
        if (protocolsOfType && numProtocolsOfType > 1) {
          console.warn(`Got ${numProtocolsOfType} protocol objects under ${protocolType} key, will only show the first one`)
        }

        const selectedProtocol = protocolsOfType && protocolsOfType[0]

        return {
          fields: (selectedProtocol && selectedProtocol.fields) || [],
          content: (selectedProtocol && selectedProtocol.content) || '# missing content!?!? something went wrong with Protocol Library',
          customLabwareDefs: (selectedProtocol && selectedProtocol.custom_labware_defs) || []
        }
      },
      getIframeSrc: function () {
        let protocol = this.protocol
        if (!(protocol && protocol.flags['embedded-app'])) {
          return false
        }
        // take all url args (if any) and pass them into the iframe. For analytics.
        let pattern = /\?(.*)/g
        let urlLocationArgs = pattern.exec(window.location.href)
        let urlSuffix = (urlLocationArgs && urlLocationArgs[1]) ? '&' + urlLocationArgs[1] : ''
        // Add timestamp to bust iframe caching (if some browsers see same URL src, they don't reload iframe contents)
        return protocol && protocol.flags['embedded-app'] + '?timestamp=' + Date.now() + urlSuffix
      },
      tabNames: () => ({ot1: 'OT-One', ot2: 'OT-2'})
    },
    components: {
      Protocol,
      Setup,
      Categories,
      Breadcrumb,
      Error404Page,
      ParameterizeAndDownload,
      EmbeddedApp
    },
    created () {
      this.fetchProtocol()
    },
    watch: {
      '$route': 'fetchProtocol'
    },
    methods: {
      fetchProtocol () {
        let that = this
        let slug = this.$route.params.slug
        db.getProtocol(slug).then((protocol) => {
          const ot1FileKey = 'OT 1 protocol'
          const ot2FileKey = 'OT 2 protocol'

          let baseDownloadUrl = 'https://d894fcc9rk.execute-api.us-west-2.amazonaws.com/ot_api_gw_prod/OpenTrons/Protocols/' + util.branchName + '/protocols/' + protocol.path.split('/')[1] + '/'
          const toAbsPath = filePath => baseDownloadUrl + filePath
          let ot1DownloadUrls = protocol.files[ot1FileKey].map(toAbsPath)
          let ot2DownloadUrls = protocol.files[ot2FileKey].map(toAbsPath)

          that.protocol = protocol

          // TODO: Ian 2018-09-07 support multiple files. Right now only
          // the first of each robot type is used

          const downloadUrls = {
            ot1: ot1DownloadUrls[0],
            ot2: ot2DownloadUrls[0]
          }

          let allTabs = ['ot2', 'ot1'].filter(robotKey => downloadUrls[robotKey])

          that.downloadUrls = downloadUrls
          that.allTabs = allTabs
          that.currentTab = allTabs ? allTabs[0] : null
        }, (error) => {
          if (error.status === 404) {
            that.is404 = true
          } else {
            console.error('unhandled error fetching protocol', error)
          }
        })
      },
      navigateTab (tab) {
        this.currentTab = tab
      },
      backToTop () {
        window.scroll(0, 0)
      }
    }
  }
</script>

<style>
  .ot2_deck_map_wrapper {
    width: 100%;
  }
  .ot2_deck_map {
    width: 60%;
    margin: auto;
  }

  .ot2_deck_map iframe {
    border: none;
    width: 100%;
    height: 40vw;
  }
</style>



// WEBPACK FOOTER //
// ProtocolView.vue?6b8b85f1